<script setup lang="ts">
import { ref } from 'vue'
import PulseCircle from '@/components/lib/PulseCircle.vue'
import { fl_followMouse } from '@/components/lib/GwUtils/utils_float'

interface CursorPulseCircleProps {
  elementBlacklistIds?: string[]
}
const props = defineProps<CursorPulseCircleProps>()

const cursorAreaRef = ref<HTMLElement | null>(null)
const pulseCircleRef = ref<HTMLElement | null>(null)
const visible = ref(false)

const handleMouseMove = (event: MouseEvent) => {
  if (
    !cursorAreaRef.value ||
    window.innerWidth < 768 ||
    props.elementBlacklistIds?.some(elId => {
      const el = document.getElementById(elId)
      if (!el) return false
      const { top: t, left: l, bottom, right } = el.getBoundingClientRect()
      return (
        event.clientX >= l &&
        event.clientX <= right &&
        event.clientY >= t &&
        event.clientY <= bottom
      )
    })
  ) {
    visible.value = false
    return
  }

  visible.value = true
  fl_followMouse(event, document.body, pulseCircleRef.value)
}
</script>

<template>
  <div
    ref="cursorAreaRef"
    class="cursor_area_wrapper"
    @mousemove="handleMouseMove"
    @mouseleave="visible = false"
    @mouseenter="visible = true"
  >
    <slot class="cursor_area"></slot>
    <div
      v-show="visible"
      ref="pulseCircleRef"
      class="cursor_circle"
    >
      <PulseCircle
        :isVisible="true"
        style="--size: 1rem; --clr-primary: var(--clr-primary-brand)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.cursor_area,
.cursor_area_wrapper {
  cursor: none;
  position: relative;
}
.cursor_circle {
  cursor: none;
  position: absolute;
  z-index: 9999;
}
</style>
